import { MovieOpenPlusOutlineIcon } from './MovieOpenPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A060D40D-A702-4EA0-9B66-95C31103C223
 * name movie-open-plus-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-plus-outline.svg
 * tags
 * - Video / Movie 
 */
export const FilmOpenPlusOutlineIcon = MovieOpenPlusOutlineIcon;
export default FilmOpenPlusOutlineIcon